import styled from 'styled-components';

import { media } from 'styles/utils';

export const StyledCalendar = styled.div`
  position: relative;
  width: 100%;
  min-width: 200px;

  .DayPicker {
    width: 100%;
  }

  .DayPickerInput-Overlay {
    overflow: hidden;
    box-shadow: 0px 8px 16px rgba(26, 32, 44, 0.05);
  }

  .DayPickerInput-OverlayWrapper {
    position: absolute;
    z-index: 2;
    left: 0;
    right: 0;
    padding: 0;
  }

  .DayPicker-wrapper {
    padding: 0;
  }

  .DayPicker-Months {
    padding: 0;
  }

  .DayPicker-Month {
    width: 100%;
    margin: 0;
    border-spacing: 3px;
    border-collapse: separate;
  }

  .DayPicker-Caption div {
    font-size: 22px;
    font-weight: 600;
    line-height: 30px;
    color: ${({ theme }) => theme.colors.black};
  }

  .DayPicker-Day,
  .DayPicker-Weekday,
  .DayPicker-WeekNumber {
    height: 40px;
    width: 40px;
    max-width: 40px;
    max-height: 40px;
    margin: 6px;
    font-size: 14px;
    padding: 0;

    ${media.tablet`
      height: 40px;
      width: 40px;
      font-size: 16px;
    `}
  }

  .DayPicker-WeekNumber,
  .DayPicker-Weekday {
    color: ${({ theme }) => theme.colors.gray.dark};
    vertical-align: middle;
  }

  .DayPicker-Day {
    border-radius: 50%;
  }

  .DayPicker-Day--selected {
    background-color: ${({ theme }) => theme.colors.primary} !important;
  }

  .DayPicker-Day:not(.DayPicker-Day--disabled):hover,
  .DayPicker-Day--selected:not(.DayPicker-Day--disabled):hover {
    color: ${({ theme }) => theme.colors.white} !important;
    background-color: ${({ theme }) => theme.colors.primary} !important;
  }

  .DayPicker-Day--disabled {
    pointer-events: none;
  }

  .DayPicker-Day--today {
    color: ${({ theme }) => theme.colors.primary};
  }

  .DayPicker-Day--outside {
    cursor: pointer;
    color: ${({ theme }) => theme.colors.gray.dark};
    opacity: .4;

    &:hover {
      opacity: 1;
    }
  }

  .DayPicker-Day--selected:not(.DayPicker-Day--disabled):not(.DayPicker-Day--outside) {
    font-weight: 500;
  }
`;

